<div style="flex-grow: 1;display: flex;flex-direction: column;overflow: hidden;">
  <!-- Header -->
  <div class='flex-header'></div>
  <!-- Body -->
  <div class='flex-content'>
    <div style="height:100%; display: flex;flex-direction: column;overflow: auto;">
      <mat-table #table [dataSource]="dataSource" matSortDisableClear matSort id="tblDataDefGrid" matSortDirection="asc"
        cdkDropList (cdkDropListDropped)="rowDrop($event)" [cdkDropListDisabled]="!dataDefList.IsSortable"
        [matSortDisabled]="dataDefList.IsSortable">

        <!-- Drag Handle Column -->
        <ng-container matColumnDef='drag-handle'>
          <mat-header-cell *matHeaderCellDef translate>
            <!-- DELIBERATELY LEFT BLANK -->
          </mat-header-cell>
          <mat-cell *matCellDef="let field" cdkDragHandle>
            <img alt="Re-Order" title="Re-Order" src="./assets/images/grip.png" style="width: 10px">
          </mat-cell>
        </ng-container>

        <!-- Code -->
        <ng-container matColumnDef="Code">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Code
            <filter class="mat-filter" [data]="dataSource" columnName="Code" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Code}} </mat-cell>
        </ng-container>

        <!-- Description -->
        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Description
            <filter class="mat-filter" [data]="dataSource" columnName="Description" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Description}} </mat-cell>
        </ng-container>

        <!-- Abbreviation -->
        <ng-container matColumnDef="Abbreviation">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Abbreviation
            <filter class="mat-filter" [data]="dataSource" columnName="Abbreviation" dataType="string"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Abbreviation}} </mat-cell>
        </ng-container>

        <!-- State Reporting -->
        <ng-container matColumnDef="IsStateReporting">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left:15px;">
            State Reporting
            <filter [data]="dataSource" columnName="IsStateReporting" dataType="boolean" trueValue="true"
              falseValue="false" showTrueLabel="Yes" showFalseLabel="No" class="mat-filter"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.IsStateReporting ? 'Y' : ''}} </mat-cell>
        </ng-container>

        <!-- Default -->
        <ng-container matColumnDef="IsDefault">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left:15px;">
            Default
            <filter [data]="dataSource" columnName="IsDefault" dataType="boolean" trueValue="true" falseValue="false"
              showTrueLabel="Y" showFalseLabel="" class="mat-filter"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.IsDefault ? 'Y' : ''}} </mat-cell>
        </ng-container>

        <!-- Inactive -->
        <ng-container matColumnDef="Inactive">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left:15px;">
            Inactive
            <filter [data]="dataSource" columnName="Inactive" dataType="boolean" trueValue="true" falseValue="false"
              showTrueLabel="Y" showFalseLabel="" class="mat-filter"></filter>
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.Inactive ? 'Y' : ''}} </mat-cell>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="Actions">
          <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
          <mat-cell *matCellDef="let element; let i = dataIndex;">
            <span *ngIf="dataDefList.LockSystemCodes" (click)="editClick(element)"><a>{{(element.IsSysGen)? 'View' :
                'Edit'}}</a></span>
            <span *ngIf="!dataDefList.LockSystemCodes && (dataDefList.CodeNotRequired || (element.Code && element.Code.trim())) && element.Description"
              (click)="editClick(element)"><a>Edit</a></span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = renderIndex;" id="tblLookupGridDataRow{{i}}"
          style="padding:0px;overflow: hidden;" matRipple cdkDrag [cdkDragData]="row">
        </mat-row>
      </mat-table>
      <span *ngIf="dataDefList.IsSortable" style="color: #9e9e9e;">Drag rows up or down to change the display
        order</span>
    </div>
  </div>